import _ from 'lodash'
let numeral = require('numeral')
let dayjs = require('dayjs')
/**
 *サピエンスさんからの回答の通り、
桁数はSOSIを含めての桁数となります。
例(→←がSOSI)
①→あいうえお← (12桁となります)
②→あい←ABC→うえお← (17桁となります。)
 ※あいうえおは全角文字、ABCは半角文字
 ※全角文字の開始と終了箇所にはSOSIあります。
 */
export function calcSosi(string) {
  var count = 0
  if (!string) {
    return count
  }
  string = _.toString(string)
  //全角文字のマッチ
  var exp = /([^\x00-\xff|\uff61-\uff9f]+)/gi
  var matchers = string.match(exp)
  return matchers ? matchers.length * 2 : 0
}
/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function formatTimeDayLong(cell, formate, end = false) {
  if (!cell) {
    if (end) {
      return '23:59'
    } else {
      return '00:00'
    }
  }
  return dayjs(dayjs().format('YYYY/MM/DD') + cell).format(formate)
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }

  let val = decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')
    .replace(/\+/g, ' ')
  return JSON.parse('{"' + val + '"}')
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
  const parent = data.filter(
    (value) => value.parentId === 'undefined' || value.parentId === null
  )
  const children = data.filter(
    (value) => value.parentId !== 'undefined' && value.parentId !== null
  )
  const translator = (parent, children) => {
    parent.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parent, children)
  return parent
}

/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = []
  data.forEach((item) => {
    const loop = (data) => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      })
      const child = data.children
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i])
        }
      }
    }
    loop(item)
  })
  return result
}

/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let str = ''
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length))
  }
  return str
}

/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}

/**
 * @description 获取字符串的存储长度
 * @param {*} string
 */
export function getZFWlength(string) {
  var count = 0
  for (var i = 0; i < string.length; i++) {
    //对每一位字符串进行判断，如果Unicode编码在0-127，计数器+1；否则+2
    if (string.charCodeAt(i) < 128 && string.charCodeAt(i) >= 0) {
      count++
    } else {
      count += 2
    }
  }
  return count
}

/**
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description 数组打乱
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
  let m = array.length,
    t,
    i
  while (m) {
    i = Math.floor(Math.random() * m--)
    t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}
export function formatDate(cell, format = 'YYYY/MM/DD') {
  if (!cell) {
    return cell
  }
  return dayjs(cell).format(format)
}
export function formatDateTime(cell, format = 'YYYY/MM/DD HH:mm') {
  if (!cell) {
    return cell
  }
  return dayjs(cell).format(format)
}
export function formatTimeDefault(cell, formate, end = false) {
  if (!cell) {
    if (end) {
      return '23:59:59:000'
    } else {
      return '00:00:00:000'
    }
  }
  return dayjs(dayjs().format('YYYY/MM/DD') + cell).format(formate)
}

/**
 *文字列の切り出しを行う方法
 * @param {*} str
 * @param {*} length
 * @returns
 */
export function cutString(str, start, length) {
  if (_.isEmpty(str)) {
    return str
  }

  if (str.length < length) {
    return str
  }

  return str.substring(start, length)
}

/**
 *
 * @param {*} cell
 * @param {*} format  http://numeraljs.com
 * @returns
 */
export function formatNumber(cell, format = '0,0') {
  if (!cell) {
    return cell
  }
  return numeral(cell).format(format)
}

export function formatEnum(cell, format) {
  console.info(format)
  return cell
}

export function formatCell(cell, type, format) {
  switch (type) {
    case 'date':
      return formatDate(cell, format)
    case 'number':
      return formatNumber(cell, format)
    default:
      return cell ?? ''
  }
}

//テクストを取得する
export const getEnumText = (value, codeEnum) => {
  if (_.isEmpty(value)) {
    return ''
  }
  return _.get(_.find(codeEnum, { value: value }), 'text')
}

//テクストを取得する
export const getEnumTextChange = (value, codeEnum) => {
  if (_.isEmpty(value)) {
    return '-'
  }
  return _.get(_.find(codeEnum, { value: value }), 'text')
}

//テクストを取得する
export const getTextValue = (value) => {
  if (_.isEmpty(value)) {
    return '-'
  }
  return value
}

export const getRangeValue = (start, end) => {
  if (!_.isEmpty(start) && !_.isEmpty(end)) {
    return `${start}~${end}`
  } else if (_.isEmpty(start) && !_.isEmpty(end)) {
    return end
  } else if (_.isEmpty(end) && !_.isEmpty(start)) {
    return start
  }
  return ''
}

//テクストを取得する
export const getEnumValue = (codeEnum) => {
  return _.get(codeEnum, 'value')
}

/**
 *オブジェクトから指定されたフィールドの値を取得します
 * @param {*} object オブジェクト
 * @param {*} prop パス
 * @param {*} deep 深さ
 * @param {*} field フィールド
 */
export function getTableCellVaue(object, prop, deep, field) {
  if (!object) {
    return null
  }
  let arrs = []
  if (_.isString(prop)) {
    arrs = prop.split('.')
  } else {
    arrs = prop
  }
  if (deep > arrs.length) {
    return null
  }
  arrs = _.take(arrs, deep)
  if (field) {
    arrs = _.concat(arrs, field)
  }
  return _.get(object, arrs)
}
export function setTableCellValue(object, index, dataValue) {
  if (!_.isObject(dataValue)) {
    return null
  }
  Object.assign(object[index], dataValue)
}
export function setTableCellVaue(object, prop, deep, field, value) {
  if (!object) {
    return null
  }
  let arrs = []
  if (_.isString(prop)) {
    arrs = prop.split('.')
  } else {
    arrs = prop
  }
  if (deep > arrs.length) {
    return null
  }
  arrs = _.take(arrs, deep).concat(field)
  return _.set(object, arrs, value)
}

export function getTableCellRowIndex(prop, deep) {
  let arrs = []
  if (_.isString(prop)) {
    arrs = prop.split('.')
  } else {
    arrs = prop
  }
  if (deep > arrs.length) {
    return null
  }
  return _.get(arrs, deep)
}

/**
 * 根据配置修改数据类型
 * @param {} config
 */
export function valueModifies(modifiers, value) {
  if (!modifiers) {
    return value
  }

  //去掉前后空格
  if (modifiers.trim) {
    value = _.trim(value)
  }

  //首字母大写
  if (modifiers.capitalize) {
    value = value.charAt(0).toUpperCase() + value.slice(1)
  }

  //如果是数字类型，则将值转换为数值
  if (modifiers.number) {
    let v = _.toNumber(value)
    value = v ? v : value
  }

  //如果是数字类型，则将值转换为数值
  if (modifiers.integer) {
    let v = _.toInteger(value)
    value = v ? v : value
  }
  return value
}

export function getYearMonthList(startDate, endDate) {
  if (_.isEmpty(startDate) || _.isEmpty(endDate)) {
    return []
  }

  let ymList = []
  let startYM = dayjs(startDate).format('YYYY/MM')
  let endYM = dayjs(endDate).format('YYYY/MM')

  // 契約期間の時間の差は数か月
  let sums = dayjs(endYM).diff(startYM, 'month')
  for (let i = 0; i <= sums; i++) {
    ymList.push(dayjs(startYM).add(i, 'month').format('YYYY/MM'))
  }

  return ymList
}

export function weekMatching(date) {
  if (!date) return
  let ym = this.$dayjs(date).format('YYYY/MM/DD')
  let weeks = [
    {
      name: '（日）',
      val: 0,
    },
    {
      name: '（月）',
      val: 1,
    },
    {
      name: '（火）',
      val: 2,
    },
    {
      name: '（水）',
      val: 3,
    },
    {
      name: '（木）',
      val: 4,
    },
    {
      name: '（金）',
      val: 5,
    },
    {
      name: '（土）',
      val: 6,
    },
  ]
  let week = this.$dayjs(ym).day()
  let weekItem = this.$baseLodash.find(weeks, (item) => week == item.val)
  if (this.$baseLodash.isUndefined(weekItem)) return
  return weekItem.name
}

// フォーマット時間です
export function formatTimeMsel(val, type = 'HH:mm:ss') {
  if (!_.isEmpty(val)) {
    return dayjs(dayjs().format('YYYY/MM/DD ') + val).format(type)
  }
  return val
}
// フォーマット金額です
export function moneyFormat(val, decimals = 0) {
  let numeral = require('numeral')
  let format = null
  if (decimals > 0) {
    format = `0,0.${_.padEnd('0', Number(decimals), '0')}`
  } else {
    format = `0,0`
  }
  if (val) {
    return numeral(val).format(format)
  }
}
// フォーマット年月です
export function getFomateMonth(value) {
  if (_.isEmpty(value) || !dayjs(value).isValid()) return
  return dayjs(value).format('YYYY/MM')
}
//ファイルのサイズのチェック
export function checkfileSize(fileList) {
  var result = fileList
    .map((file) => file.size)
    .reduce((pre, cur) => {
      return pre + cur
    })
  const FILE_SIZE_M = 10 * 1024 * 1024
  if (result > FILE_SIZE_M) {
    this.msgError(
      this.format(
        this.$t(`validateMessage.${this.$messageCode.E00000515.name}`),
        '10MB'
      )
    )
    return false
  }

  return true
}

/**
 * 書類をチェック
 * @param {*} fileList
 * @returns
 */

export function checkEfile(fileList) {
  // ファイル名をチェックします
  let efileRegexFlag = fileList.find((item) =>
    item.name.match(/[\\/:*?"<>|+]/g)
  )
  if (efileRegexFlag) {
    this.msgError(
      this.$t(`validateMessage.${this.$messageCode.E00000621.name}`)
    )
    this.reset && this.reset()
    return true
  }
  return false
}

/// カレンダー表示データをリセット
export function resetCalender(list, resList = []) {
  let data = _.cloneDeep(list).map((v) => {
    let data = {
      day: Number(v?.day),
      acceptOrderKey: `作業No：${this.getFieldValue(
        'workingPlanAndResultIdModel.workNo',
        v
      )}`,
    }
    if (v?.workPlanStartTime && v?.workPlanEndTime) {
      data.timePeriodList = [
        {
          time: `${formatTimeMsel(
            v?.workPlanStartTime,
            'HH:mm'
          )}-${formatTimeMsel(v?.workPlanEndTime, 'HH:mm')}`,
          acceptOrderKey: `作業No：${this.getFieldValue(
            'workingPlanAndResultIdModel.workNo',
            v
          )}`,
          content: this.getFieldValue(
            'workingPlanAndResultIdModel.workName',
            v
          ),
          active: true,
        },
      ]
    } else {
      data.timePeriodList = []
    }
    return data
  })
  return getComplexList(resList, data)
}
// カレンダーの書式を変更する
export function getComplexList(resList, changeList) {
  resList.forEach((v) => {
    const keyList = changeList.map((itm) => itm.acceptOrderKey)
    v.timePeriodList.forEach((d, i) => {
      if (d?.acceptOrderKey && keyList.includes(d?.acceptOrderKey)) {
        v.timePeriodList.splice(i, 1)
      }
    })
    let day = dayjs(v.date).format('DD')
    changeList.forEach((item) => {
      if (Number(day) == Number(item.day)) {
        if (item.timePeriodList[0]) {
          v.timePeriodList.unshift(item.timePeriodList[0])
        }
      }
    })
  })
  return resList
}
// 日付間カレンダーの書式設定
export function crossDaySet(dayList, ym) {
  const lastDay = dayjs(ym).endOf('month').format('DD')
  dayList.forEach((d, i) => {
    if (d?.timePeriodList?.length > 0) {
      d.day = dayjs(d.date).format('DD')
      const endList = []
      d?.timePeriodList.forEach((itm) => {
        if (itm?.active) {
          const timeStr = itm.time.split('-')
          const start = timeStr[0]
          const end = timeStr[1]
          const sn = dayjs(d.date + start).valueOf()
          const en = dayjs(d.date + end).valueOf()
          if (sn > en) {
            itm.time = `${start}-23:59`
            if (!_.isUndefined(d.day) && Number(lastDay) != Number(d.day)) {
              endList.push({
                ...itm,
                time: `00:00-${end}`,
              })
            }
          }
        }
      })
      if (!_.isUndefined(d.day) && Number(lastDay) != Number(d.day)) {
        dayList[i + 1].timePeriodList = [
          ...endList,
          ...dayList[i + 1]?.timePeriodList,
        ]
      }
    }
  })
  return dayList
}
// アレイデフォーメーション
export function arrayReassignment(arr) {
  const combinedArr = []
  arr.forEach((obj) => {
    let combinedDayArr = combinedArr.map((d) => d?.date)
    let index = combinedDayArr.indexOf(obj.date)
    if (index > -1) {
      obj.timePeriodList = [
        ...combinedArr[index].timePeriodList,
        ...obj.timePeriodList,
      ]
      Object.assign(combinedArr[index], obj)
    } else {
      combinedArr.push(obj)
    }
  })
  return combinedArr
}
